{
  "RESET_PASSWORD": {
    "TITLE": "Återställ lösenord",
    "DESCRIPTION": "Ange e-postadressen du använder för att logga in på kontaktcentret för att få instruktioner för återställning av lösenordet.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "E-post",
      "PLACEHOLDER": "Ange din e-postadress.",
      "ERROR": "Ange en giltig e-postadress."
    },
    "API": {
      "SUCCESS_MESSAGE": "Länken för återställning av lösenord har skickats till din e-post.",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
    },
    "SUBMIT": "Skicka"
  }
}
